export default __webpack_public_path__ + "static/6-94ec51b4dec72f8f8779e14c0386b419.png";